module.exports = __webpack_public_path__ + "img/edition_4.bcb3a6ee.png";